import { graphql } from 'react-relay';

export const searchRefundV2 = graphql`
  mutation searchRefundV2Mutation(
    $corpType: CorpTypeEnum!
    $refundToken: String!
    $regNo: String
    $clientId: String
    $reSearchRequestId: Float
    $tritxReSearchRequestId: Float
    $optionalTerms: OptionalTerms
    $metaProperties: String
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
    $promotionData: PromotionData
    $affiliateData: AffiliateData
  ) {
    searchRefundV2(
      corpType: $corpType
      refundToken: $refundToken
      regNo: $regNo
      clientId: $clientId
      reSearchRequestId: $reSearchRequestId
      tritxReSearchRequestId: $tritxReSearchRequestId
      optionalTerms: $optionalTerms
      metaProperties: $metaProperties
      searchUtm: { source: $utmSource, medium: $utmMedium, campaign: $utmCampaign, term: $utmTerm, content: $utmContent }
      promotionData: $promotionData
      affiliateData: $affiliateData
    ) {
      result
      errors {
        code
      }
    }
  }
`;
